import React from 'react';
import { PIMCORE_CONTENT_BASE_URL } from '../../utils/Pimcore';
import BreadCrumbs from '../common/BreadCrumbs';
import ReusableTabs from '../common/ReusableTabs';
import investorRelationHeaderImage from '../../static/investor_image/investorHeader.png';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import { ResourceLibraryAssetItem } from '../../graphql/pimcore/modules/resourceLibrary/types/resourceLibraryItems';
import { toUrl } from '@/utils/convertImagePath';

interface PdfAssetViewerProps {
    assetItem: ResourceLibraryAssetItem;
}

const PdfAssetViewer: React.FC<PdfAssetViewerProps> = ({ assetItem }) => {
    const pdfUrl = `${PIMCORE_CONTENT_BASE_URL}${assetItem.asset!.fullpath}`;
    return (
        <ReusableTabs
            backgroundColor="#ffffff"
            bannerImage={toUrl(investorRelationHeaderImage)}
            bannerTitle={assetItem.name}
            bannerDescription={assetItem.name.length < 100 ? assetItem.description : ''}
            tabLabels={[]}
            tabKeys={['']}
            tabContents={[
                <div className="mid-width" key="pdf">
                    <div className="html-pages-wrapper">
                        <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                    </div>
                </div>,
            ]}
            bannerFontStyle={styles.bannerFont}
            subBannerFontStyle={styles.bannerFont2}
            pageName="browseAllProductHome"
            showTabs={false}
            breadcrumbs={<BreadCrumbs navigationPath="/Home/SalesAndResources/ResourceLibrary" />}
        />
    );
};

export default PdfAssetViewer;
